import { Button, Text } from '@shared/components';
import { useRefreshAuthorization } from '@shared/plugin/hooks/useRefreshAuthorization';

type AuthorizeMicrosoftInstructionsProps = {
  webIntegrationsUrl: string;
};
export const AuthorizeMicrosoftInstructions = (
  p: AuthorizeMicrosoftInstructionsProps
) => {
  const { isRefreshing, refreshAuthorization } = useRefreshAuthorization();
  return (
    <div className="flex flex-col">
      <Text type="body-sm" className="text-left text-gray-600">
        <hr className="my-2"></hr>
        <ol className="list-decimal pl-4 text-left">
          <li className="mt-2">
            Go to your Vooma integration settings:{' '}
            <a
              className="text-brand-500 inline font-semibold"
              href={p.webIntegrationsUrl}
              target="_blank"
              rel="noreferrer"
            >
              {p.webIntegrationsUrl}
            </a>
          </li>
          <li className="mt-2">
            Select the Microsoft Outlook integration.{' '}
            <div className="flex flex-row justify-center py-2">
              <div className="mr-4 h-40 w-40 rounded-full object-cover">
                <img
                  src="vooma_ms_integration_button.png"
                  alt="Vooma add-in for Outlook integration button"
                />
              </div>
            </div>
          </li>
          <li className="mt-2">
            {`Select your account, or otherwise select "Use another account" and
            log into your account.`}
          </li>
          <li className="mt-2">{`Click "Authorize".`}</li>
          <li className="mt-2">
            Wait for the authorization to complete. You should see this banner
            in the Vooma app.{' '}
            <div className="flex flex-row justify-center py-2">
              <img
                src="integration_complete.png"
                alt="Vooma integration complete"
              />
            </div>
          </li>
          <li className="mt-2">{`Click "Refresh" below.`}</li>
        </ol>
      </Text>
      <Button
        onPress={refreshAuthorization}
        variant="secondary"
        className="mt-2 w-4/5 self-center"
        isDisabled={isRefreshing}
      >
        Refresh
      </Button>
    </div>
  );
};
